__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@portal/agency-management";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@distribusion/portal-lib/auth", "0.28.4", () => (Promise.all([__webpack_require__.e(695), __webpack_require__.e(376), __webpack_require__.e(172), __webpack_require__.e(463)]).then(() => (() => (__webpack_require__(65695))))));
			register("@distribusion/portal-lib/components", "0.28.4", () => (Promise.all([__webpack_require__.e(313), __webpack_require__.e(376), __webpack_require__.e(606), __webpack_require__.e(172), __webpack_require__.e(970)]).then(() => (() => (__webpack_require__(57313))))));
			register("@distribusion/portal-lib/i18n", "0.28.4", () => (Promise.all([__webpack_require__.e(693), __webpack_require__.e(606)]).then(() => (() => (__webpack_require__(46693))))));
			register("@distribusion/portal-lib/query-client", "0.28.4", () => (Promise.all([__webpack_require__.e(463), __webpack_require__.e(605)]).then(() => (() => (__webpack_require__(79605))))));
			register("@distribusion/portal-lib/translation", "0.28.4", () => (Promise.all([__webpack_require__.e(598), __webpack_require__.e(606)]).then(() => (() => (__webpack_require__(23598))))));
			register("i18next", "22.5.1", () => (__webpack_require__.e(995).then(() => (() => (__webpack_require__(93995))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(615), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(41615))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(745), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(96745))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(21), __webpack_require__.e(376), __webpack_require__.e(970)]).then(() => (() => (__webpack_require__(29021))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(440), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(18440))))));
			register("react", "18.2.0", () => (__webpack_require__.e(474).then(() => (() => (__webpack_require__(79474))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};